const messages = {
    root: {
        menuTitle: 'Zakupy',
        pageTitle: 'Zakupy'
    },
    materialReservations: {
        menuTitle: 'Rezerwacje materiałów',
        pageTitle: 'Zakupy / Rezerwacje materiałów',
        title: 'Rezerwacje materiałów',
        actions: {
            open: 'Otwórz'
        },
        filters: {
            reservationItemNumber: 'Numer zamówienia / zlecenia...',
            materialName: 'Wyszukaj indeks po nazwie'
        },
        table: {
            headers: {
                createdAt: 'Data utworzenia',
                materialName: 'Nazwa',
                ean: 'Kod EAN',
                materialIndex: 'Indeks materiałowy',
                amountWithUOM: 'Ilość',
                xlAmountWithUOM: 'Ilość wysłana do XL',
                actions: 'Akcje'
            }
        },
        dialog: {
            title: 'Materiał - {name}',
            table: {
                headers: {
                    lp: 'Lp.',
                    number: 'Numer zamówienia / zlecenia',
                    productName: 'Nazwa produktu'
                }
            }
        },
        service: {
            fetchListError: 'Pobranie listy rezerwacji nie powiodło się.'
        }
    }
}

export default {
    messages: messages,
    locale: 'pl'
}
